import { themeQuartz } from "ag-grid-community";

/**
 * Base AG Grid theme configuration using Quartz theme with PulseWave customizations.
 * Uses Mantine theme variables for consistent styling across light and dark modes.
 */
export const agGridThemeBase = themeQuartz.withParams({
  fontFamily: "Lato, system-ui, -apple-system, sans-serif",
  headerFontFamily: "Open Sans, system-ui, -apple-system, sans-serif",
  spacing: 4,
  headerColumnResizeHandleColor: "var(--mantine-color-tertiary-3)",
  cellHorizontalPaddingScale: 0.5,
});

/**
 * Base AG Grid theme params object (for spreading or extending).
 * Use when you need to customize the base parameters further.
 */
export const agGridThemeParams = {
  fontFamily: "Lato, system-ui, -apple-system, sans-serif",
  headerFontFamily: "Open Sans, system-ui, -apple-system, sans-serif",
  spacing: 4,
  headerColumnResizeHandleColor: "var(--mantine-color-tertiary-3)",
  cellHorizontalPaddingScale: 0.5,
} as const;

/**
 * Get color-scheme-specific AG Grid theme with Mantine variables.
 * @param colorScheme - Current color scheme: "dark" or "light"
 * @param overrideParams - Optional additional theme parameters to override defaults
 * @returns Configured AG Grid theme
 */
export function getAgGridTheme(
  colorScheme: "dark" | "light",
  overrideParams?: Record<string, any>
): any {
  if (colorScheme === "dark") {
    const darkParams = {
      backgroundColor: "var(--mantine-color-body)",
      foregroundColor: "var(--mantine-color-text)",
      borderColor: "var(--mantine-color-default-border)",
      headerBackgroundColor: "var(--mantine-color-body)",
      headerTextColor: "var(--mantine-color-text)",
      rowHoverColor: "rgba(255,255,255,0.04)",
      chromeBackgroundColor: "var(--mantine-color-body)",
      ...overrideParams,
    };
    return themeQuartz.withParams(darkParams);
  }

  const lightParams = {
    backgroundColor: "#fff",
    foregroundColor: "var(--mantine-color-text)",
    borderColor: "var(--mantine-color-default-border)",
    headerBackgroundColor: "#fff",
    headerTextColor: "var(--mantine-color-text)",
    rowHoverColor: "rgba(0,0,0,0.04)",
    chromeBackgroundColor: "#fff",
    ...overrideParams,
  };
  return themeQuartz.withParams(lightParams);
}
